/*eslint-disable eqeqeq*/

import * as _ from 'lodash';

// var React = require('react-native');
// var {
//   StyleSheet,
// } = React;

var Util = {
  debug:{
    log:()=>{},
    level:{},
  },
  enableDebug:function(){
    // this.debug = require('./Debug');
  },

  timeToHours: function(time) {
    const dateInstance = new Date(time);

    let hours = dateInstance.getHours();

    if(hours < 10) {
      hours = '0' + hours;
    }

    let minutes = dateInstance.getMinutes();

    if(minutes < 10) {
      minutes = '0' + minutes;
    }

    return hours + ':' + minutes;
  },
  sctvTime: function(date) { // Date Object from 00:00:00 of a date
    const current = Date.now();
    const time = date.getTime(); // miliseconds

    let prefix = '';
    const delta = current - time;

    if( delta >= 0 && delta <= 86400000) {
      prefix = 'Hôm nay ';
    } else if ( delta < 0 && delta >= -86400000) {
      prefix = 'Ngày mai ';
    } else if ( delta > 86400000 && delta <= 2*86400000) {
      prefix = 'Hôm qua ';
    } else {
      prefix = 'Ngày ';
    }

    const dateString = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();

    return {
      prefix,
      dateString
    };
  },
  formatDateFromNow : function(timeIn)
  {
    var time = timeIn;
    switch (typeof time)
    {
      case 'number':
      {
        break;
      }
      case 'string':
      {
        time = +new Date(time);
        break;
      }
      case 'object':
      {
        if (time.constructor === Date)
        {
          time = time.getTime();
        }
        break;
      }
      default:
      {
        time = +new Date();
      }
    }
    var timeNow = new Date();
    var time_formats =
      [
        [60, 'giây', 1], // 60
        [120, '1 phút trước', '1 phút nữa'], // 60*2
        [3600, 'phút', 60], // 60*60, 60
        [7200, '1 giờ trước', '1 giờ nữa'], // 60*60*2
        [86400, 'giờ', 3600], // 60*60*24, 60*60
        [(86400 - (((timeNow.getHours()*60)+timeNow.getMinutes())*60)+timeNow.getSeconds()) + 86400, 'Hôm qua', 'Ngày mai'], // exactly tomorow
        [604800, 'Ngày', 86400], // 60*60*24*7, 60*60*24
        [1209600, 'Tuần trước', 'Tuần tới'], // 60*60*24*7*4*2
        [2419200, 'Tuần', 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, 'Tháng trước', 'Tháng tới'], // 60*60*24*7*4*2
        [29030400, 'Tháng', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, 'Năm ngoái', 'Năm tới'], // 60*60*24*7*4*12*2
        [2903040000, 'Năm', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, 'Thế kỷ trước', 'Thế kỷ tới'], // 60*60*24*7*4*12*100*2
        [58060800000, 'Thế kỷ', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
      ];
    var seconds = (+new Date() - time) / 1000;
    var token = 'trước';
    var list_choice = 1;
    if (seconds == 0)
    {
      return 'Đang diễn ra';
    }
    if (seconds < 0)
    {
      seconds = Math.abs(seconds);
      token = 'Sắp tới';
      list_choice = 2;
    }
    var i = 0;
    var format;
    //eslint-disable-next-line no-cond-assign
    while (format = time_formats[i++])
    {
      if (seconds < format[0])
      {
        if (typeof format[2] == 'string')
        {
          return format[list_choice];
        }
        else
        {
          return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
        }
      }
    }

    return time;
  },
  second2String:function(second){
    var stringReturn = '';
    var timeDu = Math.floor( second/60/60);

    if (timeDu>0) {
      stringReturn+=timeDu.toString();
      stringReturn+=':';
    }
    timeDu = Math.floor(second%(60*60)/60);

    stringReturn+=timeDu.toString();
    stringReturn+=':';

    timeDu = (second%60);

    stringReturn+='0'.repeat(2-timeDu.toString().length) + timeDu.toString();

    return stringReturn;
  },
  stringDate2Date:function(stringDate, format='HH:MM:SS-yyyy-mm-dd'){
    var date= new Date();

    if (!stringDate) {
      return date;
    }
    var indexHours= format.indexOf('HH');
    var indexMinutes= format.indexOf('MM');
    var indexSecond= format.indexOf('SS');
    var indexYear= format.indexOf('yyyy');
    var indexMonth= format.indexOf('mm');
    var indexDay= format.indexOf('dd');


    var temp = parseInt(stringDate.slice(indexYear, indexYear+4));

    if (indexYear>=0 && !isNaN(temp)) {date.setYear(temp);}
    temp = parseInt(parseInt(stringDate.slice(indexMonth, indexMonth+2))-1);
    if (indexMonth>=0 && !isNaN(temp)) {date.setMonth(temp);}
    temp = parseInt(stringDate.slice(indexDay, indexDay+2));
    if (indexDay>=0 && !isNaN(temp)) {date.setDate(temp);}

    temp = parseInt(stringDate.slice(indexHours, indexHours+2));
    if (indexHours>=0 && !isNaN(temp)) {date.setHours(temp);}
    temp = parseInt(stringDate.slice(indexMinutes, indexMinutes+2));
    if (indexMinutes>=0 && !isNaN(temp)) {date.setMinutes(temp);}
    temp = parseInt(stringDate.slice(indexSecond, indexSecond+2));
    if (indexSecond>=0 && !isNaN(temp)) {date.setSeconds(temp);}

    return date;
  },
  date2String:function(date, formatString='HH:MM - Ngày dd/mm'){
    var stringReturn = 'unknown';

    try{
      stringReturn= formatString.replace(/HH/, '0'.repeat(2-date.getHours().toString().length) + date.getHours().toString() );
      stringReturn= stringReturn.replace(/MM/, '0'.repeat(2-date.getMinutes().toString().length) +date.getMinutes().toString());
      stringReturn= stringReturn.replace(/SS/, '0'.repeat(2-date.getSeconds().toString().length) +date.getSeconds().toString());

      stringReturn= stringReturn.replace(/yyyy/, '0'.repeat(4-date.getFullYear().toString().length) +date.getFullYear().toString());
      stringReturn= stringReturn.replace(/mm/, '0'.repeat(2-(date.getMonth()+1).toString().length) +(date.getMonth()+1).toString());
      stringReturn= stringReturn.replace(/dd/, '0'.repeat(2-date.getDate().toString().length) +date.getDate().toString());
    }
    catch(ex){}

    return stringReturn;
  },
  /*eslint-disable no-redeclare,no-use-before-define*/
  formatNumber:function(number, c, d, t){
    var n = number,
      //eslint-disable-next-line no-param-reassign
      c = isNaN(c = Math.abs(c)) ? 0 : c,
      d = d == undefined ? '.' : d,
      t = t == undefined ? ',' : t,
      s = n < 0 ? '-' : '',
      i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + '',
      j = (j = i.length) > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c)
      .slice(2) : '');
  },
  /*eslint-enable no-redeclare,no-use-before-define*/
  formatObject:function(org, format={}){
    if (org === null || org === undefined ) {
      return format;
    }
    Object.keys(format).forEach((key)=>{
      if ( !org.hasOwnProperty(key)) {
        org[key] = format[key];
      }
      else if((org[key] === undefined || org[key] === null) && (format[key] !== undefined)){
        org[key] = format[key];
      }
    });

    return org;

  },
  dataProtectAndMap:function(orgIn, format={}, map={}){
    let org=orgIn;

    if ( Array.isArray(format) && !Array.isArray(org)) {
      this.debug.log('1 : WRONG TYPE', this.debug.level.WARN);
      org = [];
    }else if (typeof(format) === 'object' && typeof(org) !== 'object') {
      this.debug.log('2 : WRONG TYPE', this.debug.level.WARN);
      org = {};
    }
    else{
      if (org === null || org === undefined) {
        return format;
      }
    }


    Object.keys(format).forEach((key)=>{

      if ((!org.hasOwnProperty(key) || ( (format[key] !== undefined) && (typeof(org[key]) !== typeof(format[key])) )) && (typeof(format[key]) !== 'object') ) {
        this.debug.log('3 : WRONG TYPE ' + key, this.debug.level.WARN);
        if (map[key]) {
          org[map[key]] = Array.isArray(format[key]) ? [] : format[key];
        }
        else{
          org[key] = Array.isArray(format[key]) ? [] : format[key];
        }
      }
      else if((org[key] === undefined || org[key] === null) && (format[key] !== undefined) && (typeof(format[key]) !== 'object') ){
        this.debug.log('4 : VALUE UNDEFINED '+ key, this.debug.level.WARN);
        if (map[key]) {
          org[map[key]] = Array.isArray(format[key]) ? [] : format[key];
        }
        else{
          org[key] = Array.isArray(format[key]) ? [] : format[key];
        }
      }
      else{
        var temp;

        if(Array.isArray(format[key]) && (format[key].length===0) ){
          if ((org[key]===undefined) || (!Array.isArray(org[key])) ){
            this.debug.log('5 : WRONG TYPE ' + key, this.debug.level.WARN);
            temp =[];
          }else {
            temp = org[key];
          }
        }
        else if(Array.isArray(format[key]) && (format[key].length>0) ){
          temp = [];
          if (!org[key] || (!Array.isArray(org[key]))) {
            this.debug.log('7 : WRONG TYPE OR UNDEFINED '+key, this.debug.level.WARN);
            org[key]=[];
            if (typeof(format[key][0]) === 'object') {
              temp = [this.dataProtectAndMap(undefined, format[key][0], map)];
            }

          }else{
            org[key].forEach((current)=>{
              if (typeof(format[key][0]) === 'object') {
                temp.push(this.dataProtectAndMap(current, format[key][0], map));
              }else{
                if ((format[key][0] !== undefined) && (typeof(current) !== typeof(format[key][0]))) {
                  temp.push(format[key][0]);
                }else{
                  temp.push(current);
                }
              }
            });
          }

        }
        else if ((typeof(format[key]) === 'object') && (!Array.isArray(format[key])) ) {
          temp = this.dataProtectAndMap(org[key], format[key], map);
        }
        else{
          temp = org[key];
        }

        if (map[key]) {
          org[map[key]] = temp;
          org[key] = undefined;
        }
        else{
          org[key] = temp;
        }

      }
    });

    return org;
  },
  // dataProtectAndMap:function(org,format={},map={}){
  //   var dataRet = {};
  //   if (org === null || org === undefined) {
  //     if (typeof(format) === 'object') {
  //        org = new Object();
  //     }
  //     else{
  //      return format;
  //     }
  //   }
  //   Object.keys(format).forEach((key)=>{
  //
  //     if (!org.hasOwnProperty(key) || ((format[key] !== undefined) && (typeof(org[key]) !== typeof(format[key])))) {
  //       if (map[key]) {
  //         dataRet[map[key]] = Array.isArray(format[key]) ? [] : format[key];
  //       }
  //       else{
  //         dataRet[key] = Array.isArray(format[key]) ? [] : format[key];
  //       }
  //     }
  //     else if((org[key] === undefined || org[key] === null) && (format[key] !== undefined)){
  //       if (map[key]) {
  //         dataRet[map[key]] = Array.isArray(format[key]) ? [] : format[key];
  //       }
  //       else{
  //         dataRet[key] = Array.isArray(format[key]) ? [] : format[key];
  //       }
  //     }
  //     else{
  //       var temp ;
  //
  //       if(Array.isArray(format[key]) && (format[key].length>0) && (typeof(format[key][0]) === 'object') ){
  //         temp = [];
  //         org[key].forEach((current)=>{
  //           temp.push(this.dataProtectAndMap(current,format[key][0]));
  //         })
  //       }
  //       else if ((typeof(format[key]) === 'object') && (!Array.isArray(format[key])) ) {
  //         temp = this.dataProtectAndMap(org[key],format[key]);
  //       }
  //       else{
  //         temp = org[key];
  //       }
  //
  //       if (map[key]) {
  //         dataRet[map[key]] = temp;
  //       }
  //       else{
  //         dataRet[key] = temp;
  //       }
  //
  //     }
  //   })
  //   return dataRet;
  // }
  change_alias:function( alias )
  {
    var str = alias;

    str= str.toLowerCase();
    str= str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str= str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str= str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str= str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str= str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str= str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str= str.replace(/đ/g, 'd');
    str= str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'| |"|&|#|\[|\]|~|$|_/g, '');
    /* tìm và thay thế các kí tự đặc biệt trong chuỗi sang kí tự - */
    // str= str.replace(/-+-/g,"-"); //thay thế 2- thành 1-
    // str= str.replace(/^\-+|\-+$/g,"");
    //cắt bỏ ký tự - ở đầu và cuối chuỗi

    return str;
  },
  searchText:function(text2Search, str){
    const text2SearchArray = text2Search.split(',');

    const strTemp = this.change_alias(str);


    return text2SearchArray.some((current)=>{
      const text2SearchTemp = this.change_alias(current);

      if (!text2SearchTemp || text2SearchTemp === '') {
        return false;
      }

      return (strTemp.search(text2SearchTemp) > -1);
    });
  },
  searchTextQuick:function(text2Search, str){
    const text2SearchArray = text2Search.split(',');
    // let strTemp = this.change_alias(str)

    return text2SearchArray.some((current)=>{
      const text2SearchTemp = this.change_alias(current);

      if (!text2SearchTemp || text2SearchTemp === '') {
        return false;
      }

      return (str.search(text2SearchTemp) > -1);
    });
  },
  makeid:function (length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;

    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  },
  full2ShortUUID(fullUUID){
    if (fullUUID.length > 4) {
      const temp = fullUUID.split('-');


      return temp[0].slice(4);
    }else{
      return fullUUID;
    }
  },
  parseGroupObject(groupsInfo, mergeChild2Parent=false){
    var groupsObj={};

    Object.keys(groupsInfo).forEach((group)=>{
      const obj = groupsInfo[group];
      var temp = group.split('/');

      let tempObj = groupsObj;

      temp.forEach((current, index)=>{
        if (!tempObj[current]) {
          tempObj[current]={
            childDevice:{}
          };
        }
        tempObj = tempObj[current];
      });
      tempObj._path=group;
      Object.keys(obj).forEach((key)=>{
        tempObj[key] = {...obj[key]};
      });
      if(mergeChild2Parent){
        groupsObj[temp[0]].childDevice = Object.assign(groupsObj[temp[0]].childDevice, tempObj.childDevice);
      }
    });

    return groupsObj;
  },
  getDeviceGroupNameAndIcon(info={}, useLocalId = true, userReducer={}, deviceReducer={}){
    //info : { deviceId,propertyName }
    var ret = {
      name: info.productId || info.deviceId,
      nameLocal:info.productId || info.deviceId,
      nameDeviceType : info.productId || info.deviceId,
      icon: '',
      group : '', //groups.join(' '),
      groupsMap:[],
      groups :'',
      location: '',
      propertyId:''
    };
    var deviceId;

    if (info.deviceId) {
      deviceId = info.deviceId;
    }else if(deviceReducer.childDevicesByProductId[info.productId]){
      deviceId = deviceReducer.childDevicesByProductId[info.productId]._id;
    }else{
      return ret;
    }
    userReducer.userSetting = userReducer.userSetting || {};
    var groups = [];
    var groupsMap = {};

    Object.keys(userReducer.userSetting.groups||{}).forEach((current)=>{
      const obj = userReducer.userSetting.groups[current];

      if (obj.childDevice&&obj.childDevice[deviceId]) {
        groups.push(current);
        groupsMap[current]=obj;
      }
    });

    var deviceInfo = deviceReducer.devices[deviceId];

    if (!deviceInfo) { return ret;}
    var deviceTypeInfo = deviceReducer.devicesTypes[deviceInfo.deviceTypeId];

    if (!deviceTypeInfo) { return ret;}
    var property ={};
    var localId = '';

    if (info.property && info.property.localId) {
      localId = info.property.localId;
      property = info.property;
    }else if (info.propertyName || (info.propertyCode && info.localId) || (info.localId)) {
      let count =0;
      deviceTypeInfo.properties.some((c)=>{
        if (info.propertyName) {
          if (info.propertyName === c.name) {
            localId = c.localId;
            property = c;

            return true;
          }
        }else if(info.propertyCode && info.localId){
          if (info.localId.toString() === c.localId &&
                  deviceReducer.devicesProperties[c.propertyId] &&
                  info.propertyCode === deviceReducer.devicesProperties[c.propertyId].code ) {
            localId = c.localId;
            property = c;

            return true;
          }
        }else{
          if (info.localId.toString() === c.localId) {
            if (count>0) {
              localId = c.localId;
              property = {};

              return true;
            }
            count ++;
            localId = c.localId;
            property = c;

            return false;
          }
        }

        return false;
      });
    } else{
      let count =0;
      deviceTypeInfo.properties.some((c)=>{
        if (count>0) {
          localId = c.localId;
          property = {};

          return true;
        }
        count ++;
        localId = c.localId;
        property = c;

        return false;
      });
    }

    var propertyDetailInfo ={};
    if (property && property.propertyId) {
      propertyDetailInfo = deviceReducer.devicesProperties[property.propertyId] || {};
    }

    var nameProperty = '';
    var namePropertyLocal = '';
    if (localId && useLocalId) {
      nameProperty = _.get(userReducer, `userSetting.devices.${deviceId}.properties.localId-${localId}.name`,
        ((property.displayName || property.name)?`${property.displayName || property.name}` :undefined) ||
          ((propertyDetailInfo.displayName || propertyDetailInfo.name)?`${propertyDetailInfo.displayName || propertyDetailInfo.name}-${localId}` :undefined) );
    }else if(property){
      if (localId) {
        namePropertyLocal = _.get(userReducer, `userSetting.devices.${deviceId}.properties.localId-${localId}.name`, `${propertyDetailInfo.displayName || propertyDetailInfo.name}-${localId}` || `${property.name}` );
      }
      if (property.displayName || property.name) {
        nameProperty = property.displayName || property.name || `${propertyDetailInfo.displayName}-${localId}`;
      }
    }
    var iconLocalProperty = '';
    if (localId && useLocalId) {
      iconLocalProperty = _.get(userReducer, `userSetting.devices.${deviceId}.properties.localId-${localId}.icon`, '');
    }
    var iconProperty = '';
    iconProperty = _.get(userReducer, `userSetting.devices.${deviceId}.properties.${property.name}.icon`, '');
    var nameDevice = '';
    nameDevice = _.get(userReducer, `userSetting.devices.${deviceId}.name`, deviceTypeInfo.displayName||deviceTypeInfo.name);
    var iconDevice = '';
    iconDevice = _.get(userReducer, `userSetting.devices.${deviceId}.icon`, deviceTypeInfo.icon);

    return {
      name: nameProperty || `${nameDevice}${useLocalId?`-${localId}`:''}`,
      nameLocal:namePropertyLocal,
      nameDeviceType : deviceTypeInfo.displayName||deviceTypeInfo.name,
      icon: iconLocalProperty || iconProperty || property.icon || propertyDetailInfo.icon,
      // group : groups.join(' '),
      group : groups[0]||'', //groups.join(' '),
      groupsMap,
      groups :groups,
      location: _.get(groupsMap, `${groups[0]}._setting.location`, ''),
      propertyId:property.propertyId
    };
  },
  verifyType(value, type){
    switch (type) {
      case 'NUMBER':{
        if (typeof(value)==='boolean') {
          return (value?1:0);
        }

        return parseFloat(value) || 0;
      }
      case 'STRING':{
        return value+'';
      }
      case 'BOOLEAN':{
        if (typeof(value)==='string') {
          return (!!((value==='true'||value==='TRUE')));
        }else if(typeof(value)==='number'){
          return ((value>0));
        }else{
          return !!value;
        }
      }
      case 'DATE':{
        return new Date(value);
      }
      case 'TIME':{
        return value;
      }
      case 'COORDINATE':{
        if (Array.isArray(value) && value.length >= 2 ) {
          return value;
        }else{
          return [0, 0];
        }
      }
      default:
        return value;
    }
  },
  verifyValue(value, propertyInfo){
    if (!(Array.isArray(propertyInfo.params) && propertyInfo.params.length > 0)) {
      return value;
    }
    let retValue = value;

    if (propertyInfo.methode) {
      retValue =[];
      propertyInfo.params.forEach((c, i)=>{
        //eslint-disable-next-line no-param-reassign
        if (!Array.isArray(value)) {value=[value];}
        retValue.push(this.verifyValue( (value[i]!==undefined&&value[i]!==null)?value[i]:0, {methode:false, params:[c]} ));
      });
    }else{
      const type = propertyInfo.params[0].type || 'NUMBER';

      const rangeInfo = propertyInfo.params[0].range || [];

      const typeArray = type.split('_');
      /*eslint-disable no-param-reassign*/
      switch (typeArray[0]) {
        case 'NUMBER':{
          value = this.verifyType(value, 'NUMBER');
          retValue=value;
          rangeInfo.some((c)=>{
            if ((c.value !== undefined) && value === c.value) {
              retValue = value;

              return true;
            }else if(((value>=c.min) && (value<=c.max))||
                      ((value>=c.min) && (c.max===undefined))||
                      ((c.min===undefined) && (value<=c.max)) ) {
              retValue = value;

              return true;
            }else if( (c.max!==undefined) && (value>c.max) ){
              retValue = c.max;
            }else if( (c.min!==undefined)&&(value<c.min)){
              retValue = c.min;
            }

            return false;
          });
          break;
        }
        case 'STRING':{
          value = this.verifyType(value, 'STRING');
          retValue=value;
          break;
        }
        case 'BOOLEAN':{
          value = this.verifyType(value, 'BOOLEAN');
          retValue=false;
          break;
        }
        case 'DATE':{
          value = this.verifyType(value, 'DATE');
          retValue=false;
          break;
        }
        case 'TIME':{
          value = this.verifyType(value, 'TIME');
          retValue=false;
          break;
        }
        case 'ARRAY':{
          retValue=[];
          if (typeArray[1]) {
            if (Array.isArray(value)) {
              retValue=value.map((c)=>this.verifyType(c, typeArray[1]));
            }
          }else{
            if (Array.isArray(value)) {retValue=value;}
          }

          break;
        }
        default:
      }
      /*eslint-enable no-param-reassign*/
    }

    return retValue;
  },
  processPropertyInfo(propertyInfo){
    const ret ={
      writeable:false,
      type:'NUMBER',
      unit:'',
      verifyValue:(value)=>{return this.verifyType(value, 'NUMBER');},
      configType:'INPUT',
      viewType:'TEXT',
      guildString:'',
      rangeInfo:[]
    };

    if (!propertyInfo) {return ret;}
    ret.writeable = propertyInfo.writeable;
    if (!propertyInfo.methode && Array.isArray(propertyInfo.params) && propertyInfo.params.length === 1) {
      ret.verifyValue=(value)=>{
        return this.verifyValue(value, propertyInfo);
      };
      ret.type = propertyInfo.params[0].type;
      ret.unit = propertyInfo.params[0].unit;
      let typeArray = [''];

      if (ret.type) {
        typeArray = ret.type.split('_');
      }
      const rangeInfo = propertyInfo.params[0].range;

      if (rangeInfo) {
        if (rangeInfo.length===2 &&
                rangeInfo[0].value !== undefined &&
                rangeInfo[1].value !== undefined) {
          if (ret.writeable) {ret.configType = 'SWITCH';}
          ret.viewType = 'SWITCH';
          if (rangeInfo[0].name && rangeInfo[1].name) {
            ret.guildString = `${rangeInfo[0].name}/${rangeInfo[1].name}`;
          }
          ret.rangeInfo=rangeInfo;
        }else if (rangeInfo.length>2 && rangeInfo[0].value!==undefined){
          if (ret.writeable) {
            ret.configType = 'SELECT';
            ret.rangeInfo=rangeInfo;
          }
          ret.viewType = 'SELECT';
        }else if( typeArray[0] === 'ARRAY' && typeArray[typeArray.length-1] === 'FIX'){
          if (ret.writeable) {ret.configType = 'LIST_FIX';}
          ret.viewType = 'LIST_FIX';
        }else if( typeArray[0] === 'ARRAY' ){
          if (ret.writeable) {ret.configType = 'LIST';}
          ret.viewType = 'LIST';
        }else if( typeArray[0] === 'COORDINATE' ){
          if (ret.writeable) {ret.configType = 'MAP';}
          ret.viewType = 'TEXT';
        }else if(rangeInfo[0] && rangeInfo[0].step>0){
          if (ret.writeable && rangeInfo[0].max!==undefined && rangeInfo[0].min!==undefined) {
            ret.configType = 'SLIDE';
            ret.step=rangeInfo[0].step;
            ret.max=rangeInfo[0].max;
            ret.min=rangeInfo[0].min;
          }
          ret.viewType = 'SLIDE';
        }
      }
    }else if(propertyInfo.methode){ // method
      ret.configType = 'ACTIVATE';
      ret.guildString = 'Kích hoạt';
    }

    return ret;
  },
  getPropertyValueInfo(value, propertyInfo){
    let ret ={};

    if (!propertyInfo || !propertyInfo.params || propertyInfo.params.length===0) {
      ret.name = value+'';
      ret={
        name:value+'',
        value,
        unit:''
      };

      return ret;
    }
    //eslint-disable-next-line no-param-reassign
    value = this.verifyValue(value, propertyInfo);
    if (Array.isArray(propertyInfo.params) && propertyInfo.params.length === 1 ) {
      if (propertyInfo.params[0].range) {
        propertyInfo.params[0].range.some((c)=>{
          if ((c.value !== undefined) && value === c.value) {
            ret = c;

            return true;
          }else if(((value>=c.min) && (value<=c.max))||
                    ((value>=c.min) && (c.max===undefined))||
                    ((c.min===undefined) && (value<=c.max)) ) {
            ret = c;

            return true;
          }

          return false;
        });
      }
      ret = {
        ...ret,
        unit:propertyInfo.params[0].unit||''
      };
    }
    ret.value=value;

    return {
      ...ret,
      name:ret.name||(`${ret.value} ${ret.unit||''}`)
    };
  },
  getNextPropertyValue(value, propertyInfo){
    let index = -1,
      rangeLength = 0,
      nextIndex = -1,
      nextValue;
    //eslint-disable-next-line no-param-reassign
    value = value || 0;
    if (Array.isArray(propertyInfo.params) && propertyInfo.params.length === 1 ) {
      if (propertyInfo.params[0].range && propertyInfo.params[0].range.length>1) {
        rangeLength = propertyInfo.params[0].range.length;
        index = propertyInfo.params[0].range.findIndex((c)=>{
          if ((c.value !== undefined) && value === c.value) {
            return true;
          }

          return false;
        });
        if (index >-1 ) {
          if (index < (rangeLength-1)) {
            nextIndex = index+1;
          }else{
            nextIndex = 0;
          }
        }
      }else if(propertyInfo.params[0].range){
        rangeLength = propertyInfo.params[0].range.length;
        if(rangeLength===1 &&
            propertyInfo.params[0].range[0].step>0 ){
          const rang = propertyInfo.params[0].range[0];

          if(rang.max !== undefined && (value+rang.step) <= rang.max){
            nextValue = value+1;
          }else if(rang.max !== undefined && rang.min !== undefined){
            nextValue = rang.min;
          }else if(rang.max === undefined){
            nextValue = value+rang.step;
          }
        }
      }
    }
    if (nextIndex>-1) {
      nextValue = propertyInfo.params[0].range[nextIndex].value;
    }

    return nextValue;
  },
  getParamValueInfo(value, paramInfo){
    let ret ={name:value+'', value:value};

    if (!paramInfo || !paramInfo.range || paramInfo.range.length===0) {
      return ret;
    }
    //eslint-disable-next-line no-param-reassign
    value = this.verifyType(value, paramInfo.type);
    if (paramInfo.range) {
      paramInfo.range.some((c)=>{
        if ((c.value !== undefined) && value === c.value) {
          ret = c;

          return true;
        }else if(((value>=c.min) && (value<=c.max))||
                  ((value>=c.min) && (c.max===undefined))||
                  ((c.min===undefined) && (value<=c.max)) ) {
          ret = c;

          return true;
        }

        return false;
      });
    }

    return ret;
  },
  processAutomaticConditionInfo(condition, automatic, user, additionInfo){
    const ret = {
      focusText:'...',
      infoText:'...',
      color:'',
      // value:,
    };

    if(!automatic.conditions || !automatic.plugins) {return ret;}
    const conditionInfo = automatic.conditions[condition.id];

    if(!conditionInfo) {return ret;}
    const pluginInfo = automatic.plugins[conditionInfo.pluginId];

    if(!pluginInfo) {return ret;}
    if(pluginInfo.name == 'Thiết bị makipos'){
      if(conditionInfo.name == 'Điều kiện giá trị'){
        if(!additionInfo.device) {return ret;}
        const {name:deviceName, icon, group:deviceGroup, propertyId} = this.getDeviceGroupNameAndIcon({
          deviceId:condition.paramsValue.deviceId,
          propertyName:condition.paramsValue.propertyName
        }, true, user, additionInfo.device);

        const paramValueInfo = this.getParamValueInfo(condition.paramsValue.type, conditionInfo.params.find((c)=>c.name=='type'));

        const valueInfo = Util.getPropertyValueInfo(condition.paramsValue.minValue, _.get(additionInfo.device, `devicesProperties.${propertyId}`, {}));

        ret.value = valueInfo.value;
        /*eslint-disable no-fallthrough*/
        switch (paramValueInfo.name) {
          case 'bằng':{
            ret.focusText = valueInfo.name||'';
            ret.color = valueInfo.color;
            ret.infoText = `${deviceName}${deviceGroup?' trong ':''}${deviceGroup}`;
            break;
          }
          case 'khác':{}
          case 'lớn hơn':{}
          case 'lớn hơn hoặc bằng':{}
          case 'nhỏ hơn':{}
          case 'nhỏ hơn hoặc bằng':{
            ret.focusText = paramValueInfo.name||'';
            ret.infoText = `${valueInfo.name} ${deviceName}${deviceGroup?' trong ':''}${deviceGroup}`;
            break;
          }
          case 'trong khoảng':{}
          case 'ngoài khoảng':{}
          case 'trong đoạn':{}
          case 'ngoài đoạn':{
            const valueInfoMax = Util.getPropertyValueInfo(condition.paramsValue.maxValue, _.get(additionInfo.device, `devicesProperties.${propertyId}`, {}));

            ret.focusText = paramValueInfo.name||'';
            ret.infoText = `${valueInfo.name}-${valueInfoMax.name} ${deviceName} trong ${deviceGroup}`;
            break;
          }
          default:

        }
        /*eslint-enable no-fallthrough*/
      }else if(conditionInfo.name == 'Trạng thái kết nối mạng của điện thoại'){
        const type = this.getParamValueInfo(condition.paramsValue.type, conditionInfo.params.find((c)=>c.name=='type'));

        const connectivityType = this.getParamValueInfo(condition.paramsValue.connectivityType, conditionInfo.params.find((c)=>c.name=='connectivityType'));

        const connectivityName = this.getParamValueInfo(condition.paramsValue.connectivityName, conditionInfo.params.find((c)=>c.name=='connectivityName'));

        ret.focusText = (type.value==='=='?'Kết nối':'Không kết nối');
        ret.value = (type.value==='==');
        ret.infoText = (connectivityType.name==='WIFI'?connectivityName.name:connectivityType.name);
      }else{
        ret.infoText = conditionInfo.name;
      }
    }else{
      ret.infoText = pluginInfo.name;
    }

    return ret;
  },
  processAutomaticActionInfo(action, automatic, user, additionInfo){
    const ret = {
      focusText:'...',
      infoText:'...',
      color:'',
      // value:,
    };

    if(!automatic.actions || !automatic.plugins) {return ret;}
    const actionInfo = automatic.actions[action.id];

    if(!actionInfo) {return ret;}
    const pluginInfo = automatic.plugins[actionInfo.pluginId];

    if(!pluginInfo) {return ret;}

    if(pluginInfo.name == 'Thiết bị makipos'){
      if(actionInfo.name == 'Điều khiển thiết bị'){
        if(!additionInfo.device) {return ret;}
        const {name:deviceName, icon, group:deviceGroup, propertyId} = this.getDeviceGroupNameAndIcon({
          deviceId:action.paramsValue.deviceId,
          propertyName:action.paramsValue.propertyName
        }, true, user, additionInfo.device);

        let value = action.paramsValue.value;

        try{
          const commandObj = JSON.parse(action.paramsValue.commandString);

          value = (commandObj.data!=undefined?commandObj.data:commandObj.d);
        }catch(err){}

        const valueInfo = Util.getPropertyValueInfo(value, _.get(additionInfo.device, `devicesProperties.${propertyId}`, {}));

        ret.value = valueInfo.value;
        ret.focusText = valueInfo.name||'';
        ret.color = valueInfo.color;
        ret.infoText = `${deviceName}${deviceGroup?' trong ':' '}${deviceGroup}`;
      }else if(actionInfo.name == 'Kích hoạt kịch bản'){
        ret.focusText = 'Kích hoạt';
        ret.color = '#52be92';
        ret.infoText = action.paramsValue.schemaName;
      }else{
        ret.infoText = actionInfo.name;
      }
    }else{
      ret.infoText = pluginInfo.name;
    }

    return ret;
  },
  processMessage(message, processFunc){
    let retMessage = message;
    const pattern = message.match(/{[^{}]+}/gi);

    if (Array.isArray(pattern) ) {
      pattern.forEach((c)=>{
        if (c) {
          const cTemp =c.replace(/[{}]/gi, '');
          const element = cTemp.split(':');

          if (element.length===2) {
            retMessage = retMessage.replace(c, processFunc ? processFunc(element[0], element[1]) : element[1] );
          }
        }
      });
    }

    return retMessage;
  },
  processMessageObj(topicArray, messageObj){
    if(topicArray[0]==='d' && topicArray[2]==='p'){
      //eslint-disable-next-line no-param-reassign
      messageObj=Object.assign(messageObj, {
        messageId:messageObj.mid||messageObj.messageId,
        responseId:messageObj.rid||messageObj.responseId,
        eventType:topicArray[3]||messageObj.et||messageObj.eventType,
        time:messageObj.t||messageObj.time,
        // url:
        method:messageObj.m||messageObj.method,
        params:messageObj.p||messageObj.params,
        localId:messageObj.lid||messageObj.localId,
        propertyCode:messageObj.pc||messageObj.propertyCode,
        propertyName:messageObj.pn||messageObj.propertyName,
        code: (messageObj.c!==undefined?messageObj.c:messageObj.code),
        data: (messageObj.d!==undefined?messageObj.d:messageObj.data),
        user:messageObj.u||messageObj.user,
        reason:messageObj.r||messageObj.reason,
        protocol:messageObj.pr||messageObj.protocol||'MQTT',
        info:messageObj.i||messageObj.info,
        automaticRulesDone:messageObj.ard||messageObj.automaticRulesDone, //array
        automaticActionsDone:messageObj.aad||messageObj.automaticActionsDone, //array
        mid:undefined, rid:undefined,
        t:undefined, m:undefined, p:undefined, lid:undefined, pc:undefined, pn:undefined, d:undefined, u:undefined, r:undefined, pr:undefined, i:undefined,
        c:undefined,
        ard:undefined, aad:undefined,
      });
      if (topicArray.length>=6) {
        //eslint-disable-next-line no-param-reassign
        messageObj=Object.assign(messageObj, {
          localId:topicArray[4],
          propertyCode:topicArray[5]
        });
      }
    }else if(topicArray[0]==='d' && topicArray[2]==='s'){
      //eslint-disable-next-line no-param-reassign
      messageObj=Object.assign(messageObj, {
        messageId:messageObj.mid||messageObj.messageId,
        responseId:messageObj.rid||messageObj.responseId,
        user:topicArray[3]||messageObj.u||messageObj.user,
        eventType:topicArray[4]||messageObj.et||messageObj.eventType,
        time:messageObj.t||messageObj.time,
        code: messageObj.c||messageObj.code,
        data: (messageObj.d!==undefined?messageObj.d:messageObj.data),
        reason:messageObj.r||messageObj.reason,
        protocol:messageObj.pr||messageObj.protocol||'MQTT',
        info:messageObj.i||messageObj.info,
        mid:undefined, rid:undefined,
        et:undefined, t:undefined, c:undefined, d:undefined, u:undefined, r:undefined, pr:undefined, i:undefined
      });
      if (topicArray.length>=7) {
        //eslint-disable-next-line no-param-reassign
        messageObj=Object.assign(messageObj, {
          localId:topicArray[5]||messageObj.lid,
          propertyCode:topicArray[6]||messageObj.pc,
          lid:undefined,
          pc:undefined
        });
      }
    }

    return messageObj;
  }
};


export default Util;
